<template>
  <form @submit.prevent="tryToSubmit">
    <b-field>
      <b-input
	v-model="term"
	:expanded="true"
	:placeholder='$t("Enter search term here, e.g. Maier ...")'
	type="search"
	icon="search"
      >
      </b-input>
      <p class="control">
	<b-button
	  v-if="hasTerm"
	  @click="reset"
	  icon-left="times"
	  tag="a"
	  type="button"
	>
	</b-button>
      </p>
      <p class="control">
	<b-button
	  @click="tryToSubmit"
	  :disabled="!canSubmit"
	  tag="button"
	  :loading="isLoading"
	  type="submit"
	  class="is-primary"
	>
	  {{$t('Search')}}
	</b-button>
      </p>
    </b-field>
    <SearchOptions>
      <SearchOptionFuzzy v-model="filters.fuzziness" />
    </SearchOptions>
  </form>
</template>

<script>
 import SearchOptions from '@/components/SearchOptions.vue'
 import SearchOptionFuzzy from '@/components/SearchOptionFuzzy.vue'
 import utilsMixin from '@/mixins/utils.js'

 import { debounce } from '@/utils/misc.js'

 import { createValidator } from '@/utils/validation.js'
 import { createMapper } from '@/utils/mapping.js'

 const validator = createValidator('search-form')
 const mapper = createMapper('search-form')

 export default {
   components: {
     SearchOptions,
     SearchOptionFuzzy
   },
   mixins: [utilsMixin],
   data() {
     return {
       isLoading: false,
       isFiltersOpen: false,
       term: '',
       filters: {
	 types: [],
	 gemeinden: [],
	 fuzziness: 1
       }
     }
   },
   watch: {
     '$route.query': {
       handler: 'syncFromQuery',
       immediate: true,
       deep: true
     }
   },
   computed: {
     canSubmit() {
       return !!this.term
     },
     hasChanges() {
       return !this.isDeepEqual(
	 this.cleanQuery(this.query),
	 this.cleanQuery(mapper.fromURL(this.$route.query))
       )
     },
     routeQuery() {
       return mapper.fromURL(this.$route.query)
     },
     hasTerm() {
       return !!this.routeQuery.term
     },
     query() {
       console.log(this.filters)
       return {
	 term: this.term,
	 ...this.filters
       }
     }
   },
   mounted() {
     this.tryToSubmit()
   },
   methods: {
     syncFromQuery(query) {
       let {
	 term,
	 types = [],
	 titles = [],
	 fuzziness = null
       } = this.cleanQuery(mapper.fromURL(query))

       if (fuzziness === null) {
	 fuzziness = validator.getDefault('fuzziness')
       }

       this.term = term
       Object.assign(this.filters, { types, titles, fuzziness })
     },
     syncWithQuery() {
       const query = mapper.toURL(this.cleanQuery(this.query))
       this.$router.push({ query })
     },
     cleanQuery(query) {
       // FIXME: handle valid parameters
       if (validator.isValid(query)) {
	 return validator.clean(query)
       }
       else {
	 // clear everything
	 return {}
       }
     },
     reset() {
       this.term = ''
       Object.assign(this.filters, {
	 types: [],
	 gemeinden: []
       })
       this.syncWithQuery()
     },
     tryToSubmit() {
       if (this.canSubmit) {
	 this.submit()
       }
     },
     submit: debounce(function () {
       this.syncWithQuery()
       this.isFiltersOpen = false
       this.$emit('submit', this.query)
     }, 50)
   }
 }
</script>
